import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Period } from '@/types/date';
import { formatPreviousDateRangeText } from '@/utils/date';

const usePreviousDateRangeText = (previousDateRangePeriod: Period) => {
  const { t } = useTranslation();

  return useMemo(() => formatPreviousDateRangeText(previousDateRangePeriod, t), [previousDateRangePeriod, t]);
};

export default usePreviousDateRangeText;
